<template>
	<form class="form-sections" @submit.prevent>
		<ContactInformation v-if="contactInformationVisible" />

		<BillingAddress />

		<UseShippingAsBillingAddress v-if="shippingAddressToggleVisible" />

		<ShippingAddress v-if="shippingAddressVisible" />

		<ShippingOptions v-if="!isDigitalProduct" />

		<div class="form-sections__payment">
			<Payment />
		</div>

		<BAlert :show="isInternational" variant="warning">
			<b>International Customers</b> - please be advised that by placing
			your order, you acknowledge that the customer is responsible for any
			value-added-taxes or customs fees that are imposed when importing
			our products into your country. Please check with your local customs
			agency for more information.
		</BAlert>

		<Bumpers v-if="hasBumpers && isMobile" />

		<div v-if="isMobile">
			<LeadLockup lead="Order Summary" />
			<OrderSummary />
		</div>

		<Bumpers v-if="hasBumpers && !isMobile" />

		<CheckoutButton v-show="checkoutButtonVisible" />

		<TrustBanner />
	</form>
</template>

<script>
import { mapGetters } from 'vuex';
import { BAlert } from 'bootstrap-vue';
import { Bumpers } from '@component/user-backend/Checkout/V4/addons';
import OrderSummary from '@component/user-backend/Checkout/V4/OrderSummary.vue';
import LeadLockup from '@component/user-backend/Checkout/V4/LeadLockup.vue';
import TrustBanner from '@component/user-backend/Checkout/V4/banners/TrustBanner.vue';
import Payment from './Payment.vue';
import ContactInformation from './ContactInformation.vue';
import ShippingOptions from './ShippingOptions.vue';
import ShippingAddress from './ShippingAddress.vue';
import BillingAddress from './BillingAddress.vue';
import UseShippingAsBillingAddress from './UseShippingAsBillingAddress.vue';
import CheckoutButton from '../CheckoutButton.vue';

export default {
	components: {
		ContactInformation,
		ShippingOptions,
		ShippingAddress,
		BillingAddress,
		UseShippingAsBillingAddress,
		Payment,
		CheckoutButton,
		OrderSummary,
		LeadLockup,
		TrustBanner,
		Bumpers,
		BAlert,
	},

	computed: {
		...mapGetters('checkout', [
			'isDigitalProduct',
			'isInternational',
			'hasBumpers',
			'contactInformationVisible',
			'shippingAddressToggleVisible',
			'shippingAddressVisible',
			'checkoutButtonVisible',
		]),
		...mapGetters('responsive', ['isMobile']),
	},
};
</script>

<style lang="scss" scoped>
.form-sections {
	&__payment {
		display: flex;
		gap: var(--size-base);
		flex-direction: column;
	}

	> * {
		&:not(:last-of-type) {
			padding-bottom: 20px;
			margin-bottom: 20px;
			border-bottom: 1px solid var(--gray-200);
		}
	}
}
</style>
